import * as React from 'react';

import classify from 'src/utils/classify';

import css from './card.css';


type Props = {
  header?: string;
  children: React.ReactNode;
  className?: string;
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  actionRowContent?: React.ReactNode;
};

export default class Card extends React.Component<Props> {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<Props, {}, any>'.
  render(): React.ReactNode {
    const {actionRowContent, children, className, header, onSave, onCancel} =
      this.props;
    const shouldRenderActionRow =
      actionRowContent != null && onSave && onCancel;

    return (
      <div className={classify(css.container, className)}>
        {header && <header className={css.header}>{header}</header>}

        {children}

        {shouldRenderActionRow && (
          <div className={css.actionRow}>
            {actionRowContent}
            {/* @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead? */}
            {onSave && <button className={css.saveButton}>Save</button>}
            {/* @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead? */}
            {onCancel && <button className={css.cancelButton}>Cancel</button>}
          </div>
        )}
      </div>
    );
  }
}
